import { render } from "./EditCraftModal.vue?vue&type=template&id=58fa1a52&scoped=true"
import script from "./EditCraftModal.vue?vue&type=script&lang=js"
export * from "./EditCraftModal.vue?vue&type=script&lang=js"

import "./EditCraftModal.vue?vue&type=style&index=0&id=58fa1a52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58fa1a52"]])

export default __exports__